export default __webpack_public_path__ + "static/media/web-ads.4006bf88.svg";